import { msg } from "@lingui/core/macro";
import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { useSession } from "@/lib/auth";
import { TodoListView } from "@/features/todos/components/todo-list-view";
import { getTodosCountQuery, getTodosQuery } from "@listto/shared";
import { Inbox } from "lucide-solid";
import type { PowerSyncDrizzleDB } from "@listto/powersync";
import { useI18n } from "@/providers/i18n-provider";

function InboxPage() {
  const { t } = useI18n();
  const session = useSession();
  const { userId } = session;

  return (
    <>
      <TodoListView
        title={t(msg`Inbox`)}
        icon={Inbox}
        userId={userId()}
        queryFn={(db: PowerSyncDrizzleDB, uid: string, options) =>
          getTodosQuery(db, uid, { ...options, listId: null })
        }
        countQueryFn={(db, uid) => getTodosCountQuery(db, uid, { listId: null })}
        defaultAddTodoProps={{ listId: undefined }} // undefined results in null list_id in mutation
        emptyMessage={t(msg`Your inbox is clean. Good job!`)}
        listId="inbox"
      />
      <Outlet />
    </>
  );
}

export const inboxRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/inbox",
  component: InboxPage,
});
